import calcAbilities from './calcAbilities'
import calcGeneralDetails from './calcGeneralDetails'

export default function buildDisplayedAbilitySnapshot(character) {
  if (!character || typeof character !== 'object') {
    return character
  }

  const snapshot = { ...character }

  ;['dex', 'int', 'str', 'siz', 'pow'].forEach((pfx) => {
    calcAbilities({ pfx, character: snapshot })
  })

  calcGeneralDetails({ character: snapshot })

  return snapshot
}
